import React, { useCallback, useState } from 'react'
import { TouchableOpacity, View, ViewStyle, ImageStyle, Platform, Image } from 'react-native'
import { DateTime } from 'luxon'
import { observer } from 'mobx-react-lite'

import { BorderGradient } from '../path-step/border-gradient'
import { Text } from '../text'
import { ResourceIcon } from '../resource-icon'
import { SvgIcon } from '../svg-icon'
import {
  iconPathWaitLocked,
  iconPathWaitUnlocked,
  iconLibraryPathPlayGradient,
  iconPathTopic,
  iconPathQuiz,
} from '../../assets/icons'
import { color } from '../../theme'
import { getParent } from 'mobx-state-tree'
import { useInterval } from '@trivie/core'
import { useTranslation } from 'react-i18next'
import { SvgXml } from 'react-native-svg'

export const UpNextStep = observer((props: any) => {
  const { step, onPress, node, image } = props

  const [wait, setWait] = useState(
    `Unlocks ${DateTime.fromISO(node?.unlocks_at || '').toRelative()}`,
  )
  const [lock, setLock] = useState(node?.locked)

  const upNextPhoto = step?.topic?.photo_url || step?.quiz?.photo_url

  const renderWaitIcon = () => {
    if (Platform.OS !== 'web') {
      return (
        <View style={{ position: 'absolute' }}>
          <SvgIcon size={32} src={iconPathWaitLocked} color={color.white} />
        </View>
      )
    } else {
      return (
        <svg
          style={{ position: 'absolute', transform: 'scale(2.0)' }}
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="#fff"
        >
          <path d="M15.9867 2.66675C8.62666 2.66675 2.66666 8.64008 2.66666 16.0001C2.66666 23.3601 8.62666 29.3334 15.9867 29.3334C23.36 29.3334 29.3333 23.3601 29.3333 16.0001C29.3333 8.64008 23.36 2.66675 15.9867 2.66675ZM16 26.6667C10.1067 26.6667 5.33333 21.8934 5.33333 16.0001C5.33333 10.1067 10.1067 5.33341 16 5.33341C21.8933 5.33341 26.6667 10.1067 26.6667 16.0001C26.6667 21.8934 21.8933 26.6667 16 26.6667ZM15.7067 9.33342H15.6267C15.0933 9.33342 14.6667 9.76008 14.6667 10.2934V16.5867C14.6667 17.0534 14.9067 17.4934 15.32 17.7334L20.8533 21.0534C21.3067 21.3201 21.8933 21.1867 22.16 20.7334C22.44 20.2801 22.2933 19.6801 21.8267 19.4134L16.6667 16.3467V10.2934C16.6667 9.76008 16.24 9.33342 15.7067 9.33342Z" />
        </svg>
      )
    }
  }
  const renderIcon = (fill?: string) => {
    if (lock) {
      return renderWaitIcon()
    } else {
      switch (step?.object_type) {
        case 'Survey':
          return Platform.OS === 'web' ? (
            <svg
              style={{ position: 'absolute', transform: 'scale(2.0)' }}
              viewBox="0 0 24 24"
              width="32"
              height="32"
            >
              <path
                fill="#fff"
                d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2M8 17c-.55 0-1-.45-1-1v-5c0-.55.45-1 1-1s1 .45 1 1v5c0 .55-.45 1-1 1m4 0c-.55 0-1-.45-1-1V8c0-.55.45-1 1-1s1 .45 1 1v8c0 .55-.45 1-1 1m4 0c-.55 0-1-.45-1-1v-2c0-.55.45-1 1-1s1 .45 1 1v2c0 .55-.45 1-1 1"
              ></path>
            </svg>
          ) : (
            <View style={{ position: 'absolute' }}>
              <SvgXml
                xml={`<svg width="32" height="32" viewBox="0 0 24 24">
                            <path
                              fill="#fff"
                              d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2M8 17c-.55 0-1-.45-1-1v-5c0-.55.45-1 1-1s1 .45 1 1v5c0 .55-.45 1-1 1m4 0c-.55 0-1-.45-1-1V8c0-.55.45-1 1-1s1 .45 1 1v8c0 .55-.45 1-1 1m4 0c-.55 0-1-.45-1-1v-2c0-.55.45-1 1-1s1 .45 1 1v2c0 .55-.45 1-1 1"
                            ></path>
                          </svg> `}
              />
            </View>
          )
        case 'Source':
          return (
            <View style={{ position: 'absolute', transform: [{ scale: 2.0 }] }}>
              <ResourceIcon extension={step?.source?.resource_file_type ?? 'url'} white={true} />
            </View>
          )
        case 'Topic':
          return Platform.OS === 'web' ? (
            <svg
              style={{ position: 'absolute', transform: 'scale(2.0)' }}
              fill={fill ?? '#fff'}
              width="32"
              height="32"
              viewBox="0 0 32 32"
            >
              <path d="M26.6667 8.00004H16L13.3334 5.33337H5.33335C3.86669 5.33337 2.68002 6.53337 2.68002 8.00004L2.66669 24C2.66669 25.4667 3.86669 26.6667 5.33335 26.6667H26.6667C28.1334 26.6667 29.3334 25.4667 29.3334 24V10.6667C29.3334 9.20004 28.1334 8.00004 26.6667 8.00004ZM18.6667 21.3334H8.00002V18.6667H18.6667V21.3334ZM24 16H8.00002V13.3334H24V16Z" />
            </svg>
          ) : (
            <View style={{ position: 'absolute' }}>
              <SvgIcon size={32} src={iconPathTopic} color={color.white} />
            </View>
          )
        case 'Quiz':
          return Platform.OS === 'web' ? (
            <svg
              style={{ position: 'absolute', transform: 'scale(2.0)' }}
              width="32"
              height="32"
              viewBox="0 0 32 32"
              fill={fill ?? '#fff'}
            >
              <g clipPath="url(#clip0_3999_425)">
                <path d="M14.73 27.0197V18.9447H9.90624C9.23527 18.9447 8.78191 18.1645 9.10833 17.5208L15.7818 3.53586C16.1989 2.61913 17.4864 2.95071 17.4864 3.98447V12.157H22.0925C22.7635 12.157 23.1987 12.9177 22.9086 13.5613L16.4527 27.4488C16.0175 28.385 14.73 28.0534 14.73 27.0197Z" />
              </g>
              <defs>
                <clipPath id="clip0_3999_425">
                  <rect width="32" height="32" fill="white" />
                </clipPath>
              </defs>
            </svg>
          ) : (
            <View style={{ position: 'absolute' }}>
              <SvgIcon size={32} src={iconPathQuiz} color={color.white} />
            </View>
          )
        default:
          return null
      }
    }
  }

  const { t } = useTranslation()

  const getLabel = () => {
    if (step) {
      const { label, is_completed, value } = step
      if (label === 'Award Badge') {
        return `${is_completed ? t('Notifications.Badges.badge_earned') : t('Path.earnBadge')}`
      } else if (label.includes('View Source')) {
        return t('Resources.viewResource')
      } else if (label.includes('Source Viewed')) {
        return t('Resources.sourceViewed')
      } else if (label.includes('Quiz Completed')) {
        return t('Path.quizCompleted')
      } else if (label.includes('Complete Quiz')) {
        return t('Path.completeQuiz')
      } else if (label.includes('Topic Completed')) {
        return t('Path.topicCompleted')
      } else if (label.includes('Complete Topic')) {
        return t('Path.completeTopic')
      } else if (label.includes('on Quiz')) {
        return t('Path.scoreXonQuiz', { pct: value })
      } else if (label.includes('on Topic')) {
        return t('Path.scoreXonTopic', { pct: value })
      }
    }
    return step?.label || ''
  }

  useInterval(() => {
    if (lock) {
      setWait(`Unlocks ${DateTime.fromISO(node.unlocks_at || '').toRelative()}`)
      setLock(isLocked())
    }
  }, 1000)

  const isLocked = () => {
    // if for some reason no content_user_id always mark as locked
    if (!node.metadata?.content_user_id) {
      return true
    }

    // if previous node is not complete, mark as locked
    const parent = getParent(node, 2) as any
    const currentIndex = parent.nodes.indexOf(self)
    const previousIndex = parent.nodes[currentIndex - 1]
    if (parent.nodes[previousIndex] && !parent.nodes[previousIndex].is_completed) {
      return true
    }

    // if there is an unlocks_at datetime not in the past, mark as locked
    if (node.unlocks_at) {
      const diff = DateTime.now().diff(DateTime.fromISO(node.unlocks_at), 'milliseconds').toObject()
      const { milliseconds } = diff
      return (milliseconds || 0) <= 0
    }

    // otherwise unlock
    return false
  }

  const getSubtitle = useCallback(() => {
    const subtitle =
      node?.title ||
      step?.topic?.topic_title ||
      step?.quiz?.quiz_title ||
      step?.source?.resource_title

    if (lock && node.unlocks_at && wait) {
      return `${wait} - ${subtitle}`
    }
    return subtitle?.trim()
  }, [wait, lock])

  const upNextImage =
    !lock && upNextPhoto
      ? Platform.OS !== 'web'
        ? { uri: upNextPhoto }
        : upNextPhoto
      : image || require('./blurple.png')

  if (!node) {
    return
  }

  return (
    <>
      <TouchableOpacity
        // @ts-ignore
        dataSet={{ qat: `path-up-next-${step?.reference_id}` }}
        disabled={lock}
        onPress={onPress}
        style={UP_NEXT_BTN}
      >
        <BorderGradient
          borderRadius={12}
          style={{ height: Platform.OS === 'web' ? 207 : 146 }}
          colors={['rgba(49, 119, 255, 1)', 'rgba(150, 124, 253, 1)']}
          start={{ x: 0, y: 1 }}
          end={{ x: 0, y: 0 }}
        >
          <View style={IMG_CONTAINER}>
            <Image source={upNextImage} style={UP_NEXT_IMAGE} />
            {upNextPhoto && !lock ? null : renderIcon('#fff')}
          </View>
          <View style={UP_NEXT_CONTENT}>
            <View style={UP_NEXT_LABEL}>
              <Text
                style={{ color: color.shade70, marginBottom: getSubtitle() ? 2 : 0 }}
                text={getLabel()}
                numberOfLines={1}
                variant="titleEmphasized"
              />
              <Text
                style={{ color: color.shade50 }}
                numberOfLines={1}
                text={getSubtitle()}
                variant="body2Medium"
              />
            </View>
            <SvgIcon size={42} src={lock ? iconPathWaitUnlocked : iconLibraryPathPlayGradient} />
          </View>
        </BorderGradient>
      </TouchableOpacity>
    </>
  )
})

const UP_NEXT_CONTENT: ViewStyle = {
  flexDirection: 'row',
  backgroundColor: '#fff',
  borderBottomLeftRadius: 12,
  borderBottomRightRadius: 12,
  display: 'flex',
  height: 64,
  paddingLeft: 20,
  paddingRight: Platform.OS === 'web' ? 19 : 20,
  justifyContent: 'space-between',
  paddingTop: 12,
  paddingBottom: 12,
}
const UP_NEXT_IMAGE: ImageStyle = {
  height: Platform.OS === 'web' ? 141 : 80,
  width: '100%',
  borderTopLeftRadius: 12,
  borderTopRightRadius: 12,
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
}
const IMG_CONTAINER: any = {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
}

const UP_NEXT_LABEL: ViewStyle = {
  flexDirection: 'column',
  display: 'flex',
  justifyContent: 'center',
  flex: 1,
}
const UP_NEXT_BTN: ViewStyle = {
  paddingHorizontal: Platform.OS === 'web' ? 0 : 20,
  marginBottom: 20,
}
